const actions = {
  FETCH_PROJECTS: 'FETCH_PROJECTS',
  FETCH_PROJECTS_SUCCESS: 'FETCH_PROJECTS_SUCCESS',
  FETCH_PROJECTS_ERROR: 'FETCH_PROJECTS_ERROR',
  PROJECT_SET: 'project/SET_VALUE',
  PROJECT_ADD: 'project/ADD_VALUE',
  PROJECT_DEL: 'project/DEL_VALUE',
  PROJECT_SUCCESS: 'project/SUCCESS',
  PROJECT_ERROR: 'project/ERROR',
}

export default actions
